/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Input, DatePicker, Space, Button, Card } from "antd";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useTranslation } from "react-i18next";
import { apiClient } from "../Api/AllApi";
import { formatCurrency } from "../../utils/formatters";
import "../Styles/ListPages.css";
const { RangePicker } = DatePicker;

const Reports = () => {
  const { t } = useTranslation();
  const [searchText, setSearchText] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    GetApiOrder();
  }, [startDate, endDate]);
  const GetApiOrder = async () => {
    try {
      // Create params object for the query parameters
      const params = {};
      if (startDate)
        params.start_date = dayjs(startDate).format("YYYY-MM-DD");
      if (endDate)
        params.end_date = dayjs(endDate).format("YYYY-MM-DD");

      // Use apiClient directly with params in config object
      const res = await apiClient.get("/reports/orders", { params });

      setDataSource(
        res.data.map((item) => ({
          id: item.id,
          customer: item.customer,
          total_price: item.total_price,
          amount_paid: item.amount_paid,
          productsTotal_price: item.total_price,
          sku: item.products.sku,
          outstanding_balance: item.outstanding_balance,
          payment_status: item.payment_status,
        }))
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const downloadPDF = () => {
    const doc = new jsPDF();

    // Format the start and end dates
    const formattedStartDate = startDate
      ? dayjs(startDate).format("DD/MM/YYYY")
      : "N/A";
    const formattedEndDate = endDate
      ? dayjs(endDate).format("DD/MM/YYYY")
      : "N/A";

    // Add the report title and date range
    doc.text(t("Order Reports"), 14, 10);
    doc.text(
      `${t("Date Range")}:   ${formattedEndDate} to ${formattedStartDate}`,
      14,
      20
    );

    const tableColumn = [
      t("id"),
      t("customer"),
      t("Products Total Price"),
      t("amountPaid"),
      t("payment"),
      t("balance"),
    ];

    const tableRows = dataSource.map((item, index) => [
      index + 1, // Show the row index (ID)
      item.customer,
      // item.productsTotal_price, // Uncomment if you want to show this
      item.amount_paid,
      item.total_price,
      item.payment_status,
      item.outstanding_balance,
    ]);

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 30, // Adjust the starting position to fit the date range
    });

    doc.save("Reports.pdf");
  };

  const columns = [
    {
      title: t("id"),
      key: "index",
      render: (text, record, index) => index + 1, // Display row index
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("customer")}</span>,

      dataIndex: "customer",
      key: "customer",
      filteredValue: [searchText],
      onFilter: (value, record) =>
        String(record.customer).toLowerCase().includes(value.toLowerCase()) ||
        String(record.id).toLowerCase().includes(value.toLowerCase()),
    }, {
      title: (
        <span style={{ fontWeight: "bold" }}>{t("outstandingBalance")}</span>
      ),
      dataIndex: "outstanding_balance",
      key: "outstanding_balance",
      render: (value) => formatCurrency(value, t("IQD")),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("paymentStatus")}</span>,
      dataIndex: "payment_status",
      key: "payment_status",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("amountPaid")}</span>,
      dataIndex: "amount_paid",
      key: "amount_paid",
      render: (value) => formatCurrency(value, t("IQD")),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>{t("totalPrice")}</span>,
      dataIndex: "total_price",
      key: "total_price",
      render: (value) => formatCurrency(value, t("IQD")),
    },
  ];

  return (
    <div className="list-page">
      <Card
        title={
          <span style={{ fontWeight: "600", fontSize: "1.125rem" }}>
            {t("reports")}
          </span>
        }
        bordered={false}
      >
        <Space
          style={{
            marginBottom: 16,
            display: "flex",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <Input.Search
            placeholder={t("searchPlaceholder")}
            style={{ maxWidth: 320 }}
            onSearch={(value) => setSearchText(value)}
            onChange={(e) => setSearchText(e.target.value)}
          />
          <RangePicker
            onChange={(dates) => {
              setStartDate(dates ? dates[0] : null);
              setEndDate(dates ? dates[1] : null);
            }}
            style={{ minWidth: 240 }}
          />
          <Button type="primary" onClick={downloadPDF}>
            Download PDF
          </Button>
        </Space>

        <Table
          dataSource={dataSource.map((item) => ({ ...item, key: item.id }))}
          columns={columns}
          pagination={{ pageSize: 50 }}
          scroll={{ x: 600 }}
        />
      </Card>
    </div>
  );
};

export default Reports;
